import React from "react";
import {useHistory, useParams} from "react-router";
import './Purchase.scss';
import {TigerSpinner} from "../../../global/tiger-spinner/TigerSpinner";
import GlobalConstants from "../../../config/GlobalConstants";
import {GetUnauthorizedResources} from "../../../api/SpineClient";
import {useLocation} from "react-router-dom";
import allConfigs from "./subscription/subscription_promotion_config.json";
import gtmw from "../../../api/GoogleTagManagerWrapper";

export default function PurchaseRedirect() {
    const location = useLocation();

    //Initialization
    const history = useHistory();
    const queryParams = new URLSearchParams(window.location.search);
    const selectedColor = queryParams.get("selectedColor");
    const selectedGtin = queryParams.get("selectedGtin");
    const componentId = queryParams.get("componentId");
    const discountId = queryParams.get("discountId");
    const {planVariantId} = useParams();

    window.scrollTo(0, 0);

    //Redirect to shop page if plan variant id is null
    if (planVariantId == null) {
        history.push("/" + GlobalConstants.APP_PATH + "purchase/error?code=1");
        return null;
    }

    const partnerConfig = allConfigs[planVariantId];

    if (partnerConfig) {
        gtmw.promotionView(partnerConfig.name, planVariantId);
    }

    //Load premium access feature
    GetUnauthorizedResources('api/premiumAccessFeatures/search/by-planVariantId?planVariantId=' + planVariantId, {}, 'application/json', GlobalConstants.SPINE_HOST)
        .then(r => {
            //In case of an error, redirect to the error page
            if (r.error || r.result == null) {
                history.push("/" + GlobalConstants.APP_PATH + "purchase/error?code=2");
                return null;
            }

            let premiumAccessFeature = r.result;

            let purchaseData = {
                productId: premiumAccessFeature.id,
                planVariantId: planVariantId,
                selectedColor : selectedColor,
                selectedGtin: selectedGtin,
                componentId : componentId,
                discountId : discountId,
                maxStep: 1,
                premiumAccessFeature: premiumAccessFeature,
                promotion: partnerConfig
            };

            sessionStorage.setItem('ls.purchase', JSON.stringify(purchaseData));

            if (premiumAccessFeature.iap.includes("subscription")) {
                history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/authenticate" + location.search);
            } else if (premiumAccessFeature.iap.includes("tigerticket")) {
                history.push("/" + GlobalConstants.APP_PATH + "purchase/ticket" + location.search);
            } else {
                console.log("Warning: Unsupported product type: " + premiumAccessFeature.iap);
                history.push("/" + GlobalConstants.APP_PATH + "purchase/error?code=5");
            }
    });

    //Rendering
    return (
        <div className="purchase-redirect-container">
            <TigerSpinner />
        </div>
    );
}